import Vue from 'vue'

// String에서 Python의 .format 처럼 사용하기 위해 만든 함수
if (!String.format) {
  String.format = function (format) {
    var args = Array.prototype.slice.call(arguments, 1)
    return format.replace(/{(\d*)}/g, function (match, number) {
      number = number || 0
      return typeof args[number] !== 'undefined'
        ? args[number]
        : match
    })
  }
}

// Vue filter를 Python .format처럼 사용하기 위해 만든 Wrapper 함수
Vue.filter('format', function (str, dataType = '', format = '', params = '') {
  // string
  if (dataType === 'date') {
    if (str) {
      return moment(str.replace(/\./gi, '-')).format(format)
    } else {
      return ''
    }
  } else if (dataType === 'html' && params !== '') {
    if (typeof params[str] !== 'undefined') {
      return String.format.apply(this, [format].concat(params[str]))
    } else {
      return String.format(format, str)
    }
  } else if (dataType === 'address') {
    var addressList = str.replace(/\*/gi, '').split('|')
    if (addressList.length > 1) {
      return addressList[0] + ' 외 ' + (addressList.length - 1) + '개'
    } else {
      return addressList[0]
    }
  } else if (format !== '') {
    return String.format(format, str)
  } else {
    return str
  }
})

Vue.filter('nullCheck', function (str) {
  if (str === '' || str === null || typeof str === 'undefined') {
    return '-'
  }
  return str
})

Vue.filter('intcomma', function (str) {
  if (typeof str === 'undefined') {
    return
  }
  var reg = /(^[+-]?\d+)(\d{3})/
  var n = (str + '')
  while (reg.test(n)) n = n.replace(reg, '$1' + ',' + '$2')
  return n
})

Vue.filter('toFixed', function (num, len) {
  if (num !== '') {
    return parseFloat(num).toFixed(len)
  }
})

Vue.filter('formatDate', function (date, format) {
  if (!date) return '-'
  if (date.split('T').length > 1) {
    return date.split('T')[0]
  }
})

Vue.filter('billionFormat', function (num) {
  if (num.toString().length >= 9) {
    return parseInt(num.toString().slice(0, num.toString().length - 8))
  }
})

Vue.filter('thousandFormat', function (num) {
  num = Math.round(num / 10000)
  if (num.toString().length >= 5) {
    return parseInt(num.toString().slice(num.toString().length - 4, num.toString().length))
  } else {
    return num
  }
})

Vue.filter('yearFormat', function (str) {
  str = str.toString()
  return str.split('.')[0]
})

Vue.filter('monthFormat', function (str) {
  str = str.toString()
  return Math.ceil(parseFloat(str.split('.')[1]) * 1.2)
})

Vue.filter('reverse', function (value) {
  // slice to make a copy of array, then reverse the copy
  return value.slice().reverse()
})



// WEBPACK FOOTER //
// ./src/assets/js/filter.js